import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { MERCHANT_MENU_NEW_PATH } from '../../../services/data/merchantMenuItemCreate.mock'
import { MERCHANT_MENU_IMPORT_SUCCESS_PATH } from '../../../services/data/merchantMenuImportSuccess.mock'
import { MERCHANT_MENU_UPLOAD } from '../../../services/data/merchantMenuUpload.mock'
import {
  downloadMerchantProductImportTemplate,
  importMerchantProductsCsv,
} from '../../../services/merchantProductsService'
import MerchantMenuUploadMobileCsvCard from './mobile/MerchantMenuUploadMobileCsvCard'
import MerchantMenuUploadMobileHeader from './mobile/MerchantMenuUploadMobileHeader'
import MerchantMenuUploadMobileHelp from './mobile/MerchantMenuUploadMobileHelp'
import MerchantMenuUploadMobileManualCard from './mobile/MerchantMenuUploadMobileManualCard'

export default function MerchantMenuUploadMobile() {
  const navigate = useNavigate()
  const data = MERCHANT_MENU_UPLOAD
  const mobile = data.mobile
  const [uploading, setUploading] = useState(false)
  const [error, setError] = useState('')

  const handleStartEntry = () => {
    navigate(MERCHANT_MENU_NEW_PATH)
  }

  const handleUpload = async (file) => {
    if (!file) {
      setError('Choose a CSV file first.')
      return
    }
    setUploading(true)
    setError('')
    try {
      const result = await importMerchantProductsCsv(file)
      navigate(MERCHANT_MENU_IMPORT_SUCCESS_PATH, { state: { importResult: result } })
    } catch (err) {
      setError(err.message || 'Could not import CSV.')
    } finally {
      setUploading(false)
    }
  }

  const handleDownloadTemplate = async () => {
    try {
      await downloadMerchantProductImportTemplate()
    } catch (err) {
      alert(err.message || 'Could not download template.')
    }
  }

  return (
    <div className="flex min-h-full flex-1 flex-col bg-merchant-canvas shadow-[0px_1px_2px_rgba(198,196,218,0.15)] lg:hidden">
      <MerchantMenuUploadMobileHeader title={data.title} />

      <div className="flex flex-col gap-6 px-4 py-6">
        <p className="max-w-[349px] text-[13px] leading-5 text-merchant-mobile-muted">
          {mobile.intro.subheading}
        </p>

        <div className="flex flex-col gap-4">
          <MerchantMenuUploadMobileManualCard
            manualEntry={data.manualEntry}
            onStartEntry={handleStartEntry}
          />

          <MerchantMenuUploadMobileCsvCard
            csvUpload={data.csvUpload}
            mobileCsv={mobile.csvUpload}
            onUpload={handleUpload}
            onDownloadTemplate={handleDownloadTemplate}
            uploading={uploading}
            error={error}
          />
        </div>

        <MerchantMenuUploadMobileHelp help={mobile.help} />
      </div>
    </div>
  )
}
